window.addEventListener('DOMContentLoaded', function (event) {
    jQuery(document).ready(function ($) {

        let lazyloadImages;

        if ("IntersectionObserver" in window) {
            lazyloadImages = document.querySelectorAll(".lazy");
            let imageObserver = new IntersectionObserver(function (entries, observer) {
                //console.log(observer);
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        let image = entry.target;
                        image.src = image.dataset.src;
                        image.classList.remove("lazy");
                        imageObserver.unobserve(image);
                    }
                });
            }, {
                root: document.body,
                rootMargin: "0px 0px 500px 0px"
            });

            lazyloadImages.forEach(function (image) {
                imageObserver.observe(image);
            });
        } else {
            let lazyloadThrottleTimeout;
            lazyloadImages = $(".lazy");

            function lazyload() {
                if (lazyloadThrottleTimeout) {
                    clearTimeout(lazyloadThrottleTimeout);
                }

                lazyloadThrottleTimeout = setTimeout(function () {
                    let scrollTop = $(window).scrollTop();
                    lazyloadImages.each(function () {
                        let el = $(this);
                        if (el.offset().top < window.innerHeight + scrollTop + 500) {
                            let url = el.attr("data-src");
                            el.attr("src", url);
                            el.removeClass("lazy");
                            lazyloadImages = $(".lazy");
                        }
                    });
                    if (lazyloadImages.length == 0) {
                        $(document).off("scroll");
                        $(window).off("resize");
                    }
                }, 20);
            }

            $(document).on("scroll", lazyload);
            $(window).on("resize", lazyload);
        }

        let checkboxDetailsOpener = $('.checkbox-details-opener'),
            checkboxDetails = $('.checkbox-details');
        checkboxDetailsOpener.on('click', function () {
            /* todo: если включить анимации (hide/slideUp, show/slideDown), то можно увидеть,
                что события отрабатывают по два раза. возможно, стоит разобраться */
            let needToOpen = $(this).closest('.checkbox-details-opener-container').find('.checkbox-details');
            $(checkboxDetails).not(needToOpen).slideUp();
            needToOpen.slideDown();
        });

        // map on homepage
        $('.homepage .state__map .line path, .homepage .state__map .line text, .homepage .state__map .line circle, .homepage .state__map .line line').on('click', function () {
            let id = $(this).parent().find(':first-child').attr('id').toLowerCase();
            if (id in window.statesJson) {
                location.href = window.statesJson[id].permalink;
            }
        });

        if ($('.page-blog__inputs').length) {
            fillArchiveDates();

            $('#page-blog__inputs-frm').on('submit', function (e) {
                e.preventDefault();
                filterBlogPosts();
            });

            $('#archivesSelect').on('change', function () {
                filterBlogPosts();
            });

            $('#categoriesSelect').on('change', function () {
                filterBlogPosts();
            });
        }

        function fillArchiveDates() {
            $.ajax({
                type: "POST",
                url: "/wp-json/blog_filter/get_dates/",
                error: function () {
                    console.log('error');
                },
                success: function (result) {
                    //console.log(result);
                    let options = [
                        '<option value="0" selected>Archives</option>'
                    ];

                    for (const [key, value] of Object.entries(result)) {
                        options.push('<option value="' + value + '" selected>' + key + '</option>');
                    }
                    ;

                    //console.log(options);
                    $('#archivesSelect').html(options);
                    $('#archivesSelect').val(0);
                }
            });
        }

        function filterBlogPosts() {
            let srchStr = $('#blogSearch').val();
            let date = $('#archivesSelect').val();
            let category = $('#categoriesSelect').val();

            //console.log('srch: ' + srchStr + ' | date: ' + date + ' | cat: ' + category);

            $.ajax({
                type: "POST",
                url: "/wp-json/blog_filter/filter/",
                data: {
                    "srch": srchStr,
                    "date": date,
                    "category": category
                },
                error: function () {
                    console.log('error');
                },
                success: function (result) {
                    //let obj = result;
                    //console.log(obj);
                    $('.page-blog__pages').html(result);
                }
            });
        }

        // $(document).on('click', 'a[href^="#"]', function (event) {
        //     event.preventDefault();

        //     $('html, body').animate({
        //         scrollTop: $($.attr(this, 'href')).offset().top
        //     }, 500);
        // });

        let nsw = $('#name-search-window');
        let nswClosed = $('.nsw-closed');
        let nswCollapsed = $('#name-search-window > .collapsed-view');
        let nswFullView = $('#name-search-window > .full-view');
        let nswCloseButton = $('.nsw-close');
        let nswFormStep1 = $('#step1');
        let nswFormButtonStep1 = $('#submit-step1');
        let nswFormStep2 = $('#step2');
        let nswFormButtonStep2 = $('#submit-step2');
        let nswFormStep3 = $('#step3');

        let inputCompanyName = $('input[name="companyname"]');
        let selectState = $('select[name="state"]');
        let inputName = $('input[name="name"]');
        let inputEmail = $('input[name="email"]');
        let inputPhone = $('input[name="phone"]');

        let nswClicked = false;
        let nswTimer = null;

        function startNSWTimer() {
            nswTimer = setTimeout(function () {
                if (nswClicked === false) {
                    nswCollapsed.click();
                    clearTimeout(nswTimer);
                }
            }, 5000);
        }

        function NSWOpen() {
            nswClicked = true;
            clearTimeout(nswTimer);

            nsw.removeClass('nsw-closed');
            nswCollapsed.hide();
            nsw.css('top', '43%').css('right', '-336px');
            nsw.animate({ 'right': '0' }, 200);
            nswFullView.show();
        }

        nswClosed.on('click', function () {
            if (nsw.hasClass('nsw-closed')) {
                NSWOpen();
            }
        });

        nswCollapsed.on('click', function () {
            NSWOpen();
        });

        nswCloseButton.on('click', function (e) {
            e.stopPropagation();
            nswFullView.hide();
            nsw.css('top', '50%').css('right', '0');
            nswCollapsed.show();
            nswCollapsed.css('width', '250px');
            nswCollapsed.animate({ 'width': '32px' }, 200);
            nsw.addClass('nsw-closed');
        });

        nswFormButtonStep1.on('click', function (event) {
            event.preventDefault();
            let errors = false;
            $('.tooltip').hide();
            if (!inputCompanyName.val()) {
                errors = true;
                $('.error-companyname').show();
            }
            if (!selectState.val()) {
                errors = true;
                $('.error-state').show();
            }
            if (!errors) {
                nswFormStep1.hide();
                nswFormStep2.show();
            }
        });

        nswFormButtonStep2.on('click', function (event) {
            event.preventDefault();
            let errors = false;
            $('.tooltip').hide();
            if (!inputName.val()) {
                errors = true;
                $('.error-name').show();
            }
            if (!inputEmail.val()) {
                errors = true;
                $('.error-email').show();
            }
            if (!inputPhone.val()) {
                errors = true;
                $('.error-phone').show();
            }
            if (!errors) {
                let url = '/wp-json/fns/send/';
                $.ajax({
                    method: 'POST',
                    url: url,
                    data: {
                        companyName: inputCompanyName.val(),
                        state: selectState.val(),
                        name: inputName.val(),
                        email: inputEmail.val(),
                        phone: inputPhone.val()
                    },
                    success: function (response) {
                        console.log(response);
                    }
                });
                nswFormStep2.hide();
                nswFormStep3.show();
            }
        });

        startNSWTimer();
    });
});
